import Vuex from "vuex";

import { ticketing } from "./modules/ticketing.js";
import { backend } from "./modules/backend.js";
import { recommendations } from "./modules/recommendations.js";
import { demand } from "./modules/demand.js";
import { car_share } from "./modules/car_share.js";
import { rental_car } from "./modules/rental_car.js";
import { MFITT } from "./modules/MFITT.js";
import { dbs } from "./modules/dbs.js";
import { coupon } from "./modules/coupon.js";

import { input } from "./modules/input.js";
import { view } from "./modules/view.js";
import { common } from "./modules/common.js";
import { presetTokens } from "./modules/presetTokens.js";

export default Vuex.createStore({
  strict: true,
  modules: {
    input: input,
    ticketing: ticketing,
    backend: backend,
    recommendations: recommendations,
    demand: demand,
    car_share: car_share,
    rental_car: rental_car,
    MFITT: MFITT,
    dbs: dbs,
    view: view,
    common: common,
    presetTokens: presetTokens,
    coupon: coupon,
  },
});
